<template>
  <transition name="fade">
    <div v-if="visible" class="overlay">

      <div class="card">

        <img class="icon" src="/public/rate-limit-girl.png"/>

        <h2>Слишком много запросов</h2>

        <p>
          Мы получили слишком много действий за короткое время
          и временно ограничили доступ.
        </p>

        <p class="sub">
          Попробуйте снова немного позже.
        </p>

        <button @click="goHome">
          Вернуться на главную
        </button>

        <div class="code">
          Error 429 • Rate limit exceeded
        </div>

      </div>

    </div>
  </transition>
</template>

<script setup>
import { ref, onMounted } from "vue"

const visible = ref(false)

function goHome(){
  window.location.href = "/"
}

onMounted(() => {

  window.addEventListener("rate-limit", () => {
    visible.value = true
  })

})
</script>

<style scoped>

.overlay{
  position:fixed;
  inset:0;
  background:rgba(0,0,0,.35);
  display:flex;
  align-items:center;
  justify-content:center;
  z-index:99999;
}

.card{
  background:white;
  padding:40px;
  border-radius:20px;
  max-width:420px;
  text-align:center;
}

.icon{
  width:120px;
  margin-bottom:16px;
}

h2{
  font-size:24px;
  margin-bottom:8px;
}

.sub{
  color:#666;
  font-size:14px;
}

button{
  margin-top:20px;
  background:#2173e5;
  color:white;
  border:none;
  padding:12px 20px;
  border-radius:12px;
  cursor:pointer;
}

.code{
  margin-top:16px;
  font-size:12px;
  color:#999;
}

</style>